module.exports = __webpack_public_path__ + "static/media/RobinCare-Logo_Animation-blueBckground.1e47812b.gif";